// import { createContext, useEffect, useReducer, ReactElement } from "react";
// import { LOGIN, LOGOUT } from "store/reducers/actions";
// import authReducer from "store/reducers/auth";
// import { openSnackbar } from "store/reducers/snackbar";
// import { dispatch as reduxDispatch } from "store";
// import Loader from "components/Loader";
// import axios from "utils/axios";
// import { AuthProps, JWTContextType } from "types/auth";

// const initialState: AuthProps = {
//   isLoggedIn: false,
//   isInitialized: false,
//   user: null,
//   permissions: []
// };

// const setSession = (user?: string | null) => {
//   if (user) {
//     localStorage.setItem("user", user);
//   } else {
//     localStorage.removeItem("user");
//     localStorage.removeItem("city_id");
//   }
// };

// const JWTContext = createContext<JWTContextType>({} as JWTContextType);

// export const JWTProvider = ({ children }: { children: ReactElement }) => {
//   const [state, dispatch] = useReducer(authReducer, initialState);

//   // =====================================================
//   // INIT — Load user from localStorage
//   // =====================================================
//   useEffect(() => {
//     const init = async () => {
//       try {
//         const user = localStorage.getItem("user");

//         if (user) {
//           const parsedUser = JSON.parse(user);

//           dispatch({
//             type: LOGIN,
//             payload: {
//               isLoggedIn: true,
//               user: parsedUser,
//               permissions: parsedUser.permissions || []
//             }
//           });
//         } else {
//           dispatch({ type: LOGOUT });
//         }
//       } catch (err) {
//         console.error(err);
//         dispatch({ type: LOGOUT });
//       }
//     };

//     init();
//   }, []);

//   const login = async (userName: string, password: string, city_id: string): Promise<boolean> => {
//     try {
//       const response = await axios.post("auth/login/", {
//         userName,
//         password,
//         city_id
//       });

//       const { user, status, message } = response.data;

//       if (status) {
//         // success popup
//         reduxDispatch(
//           openSnackbar({
//             open: true,
//             message,
//             variant: "alert",
//             alert: { color: "success" },
//             anchorOrigin: { vertical: "top", horizontal: "center" },
//             close: false
//           })
//         );

//         // ⭐ ADD city_id into user object
//         const finalUser = {
//           ...user,
//           selected_city: city_id     // <-- important
//         };

//         // ⭐ Save to localStorage
//         setSession(JSON.stringify(finalUser));
//         localStorage.setItem("city_id", city_id);

//         // ⭐ FIX — USE finalUser in context (NOT the original user)
//         dispatch({
//           type: LOGIN,
//           payload: {
//             isLoggedIn: true,
//             user: finalUser,                    // <-- FIXED
//             permissions: finalUser.permissions || []
//           }
//         });

//         return true;
//       } else {
//         // error popup
//         reduxDispatch(
//           openSnackbar({
//             open: true,
//             message,
//             variant: "alert",
//             alert: { color: "error" },
//             anchorOrigin: { vertical: "top", horizontal: "center" },
//             close: false
//           })
//         );

//         return false;
//       }
//     } catch (error: any) {
//       console.log(error);

//       reduxDispatch(
//         openSnackbar({
//           open: true,
//           message: "Login failed",
//           variant: "alert",
//           alert: { color: "error" },
//           anchorOrigin: { vertical: "top", horizontal: "center" },
//           close: false
//         })
//       );

//       return false;
//     }
//   };

//   // =====================================================
//   // LOGOUT
//   // =====================================================
//   const logout = () => {
//     setSession(null);
//     dispatch({ type: LOGOUT });
//   };

//   const resetPassword = async () => { };
//   const updateProfile = () => { };

//   if (!state.isInitialized) return <Loader />;

//   return (
//     <JWTContext.Provider
//       value={{
//         ...state,
//         login,
//         logout,
//         resetPassword,
//         updateProfile
//       }}
//     >
//       {children}
//     </JWTContext.Provider>
//   );
// };

// export default JWTContext;

import { createContext, useEffect, useReducer, ReactElement } from "react";

// reducer
import { LOGIN, LOGOUT } from "store/reducers/actions";
import authReducer from "store/reducers/auth";
import { openSnackbar } from "store/reducers/snackbar";
import { dispatch as reduxDispatch } from "store";

// components
import Loader from "components/Loader";
import axios from "utils/axios";

// types
import { AuthProps, JWTContextType } from "types/auth";

// ============================================================================
// INITIAL STATE
// ============================================================================
const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  permissions: []
};

// ============================================================================
// SAVE / CLEAR SESSION
// ============================================================================
const setSession = (user?: string | null) => {
  if (user) {
    localStorage.setItem("user", user);
  } else {
    localStorage.removeItem("user");
    localStorage.removeItem("city_id");
  }
};

const JWTContext = createContext<JWTContextType>({} as JWTContextType);

// ============================================================================
// PROVIDER
// ============================================================================
export const JWTProvider = ({ children }: { children: ReactElement }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  // ==========================================================================
  // INIT — Load user from localStorage
  // ==========================================================================
  useEffect(() => {
    const init = async () => {
      try {
        const storedUser = localStorage.getItem("user");

        if (storedUser) {
          const parsedUser = JSON.parse(storedUser);

          dispatch({
            type: LOGIN,
            payload: {
              isLoggedIn: true,
              user: parsedUser,
              permissions: parsedUser.permissions || []
            }
          });
        } else {
          dispatch({ type: LOGOUT });
        }
      } catch (err) {
        console.error(err);
        dispatch({ type: LOGOUT });
      }
    };

    init();
  }, []);

  // ==========================================================================
  // LOGIN
  // ==========================================================================
  const login = async (
    userName: string,
    password: string,
    city_id: string
  ): Promise<boolean> => {
    try {
      const response = await axios.post("auth/login/", {
        userName,
        password,
        city_id
      });

      const { user, status, message } = response.data;
      console.log("response user", user)
      console.log("response user City", user.cities.CityName)


      if (status) {
        // success popup
        reduxDispatch(
          openSnackbar({
            open: true,
            message,
            variant: "alert",
            alert: { color: "success" },
            anchorOrigin: { vertical: "top", horizontal: "center" },
            close: false
          })
        );

        // ⭐ Build final structured user object
        const finalUser = {
          id: user.staff_id,                         // REQUIRED
          name: user.name,
          // email: user.email || "",
          email: user.selected_city && user.selected_city.length > 0 ? user.selected_city[0].City_Name : "", 
          role: user.role_name || "",
          permissions: user.permissions || [],
          selected_city: city_id               // ⭐ save selected city
        };
        console.log("finalUser", finalUser)

        // ⭐ Save to localStorage
        setSession(JSON.stringify(finalUser));
        localStorage.setItem("city_id", city_id);

        // ⭐ Save to auth state
        dispatch({
          type: LOGIN,
          payload: {
            isLoggedIn: true,
            user: finalUser,
            permissions: finalUser.permissions || []
          }
        });
        console.log("Dispatched finalUser:", finalUser);

        return true;
      } else {
        reduxDispatch(
          openSnackbar({
            open: true,
            message,
            variant: "alert",
            alert: { color: "error" },
            anchorOrigin: { vertical: "top", horizontal: "center" },
            close: false
          })
        );
        return false;
      }
    } catch (error: any) {
      console.log(error);

      reduxDispatch(
        openSnackbar({
          open: true,
          message: "Login failed",
          variant: "alert",
          alert: { color: "error" },
          anchorOrigin: { vertical: "top", horizontal: "center" },
          close: false
        })
      );

      return false;
    }
  };

  // ==========================================================================
  // LOGOUT
  // ==========================================================================
  const logout = () => {
    setSession(null);
    dispatch({ type: LOGOUT });
  };

  const resetPassword = async () => { };
  const updateProfile = () => { };

  if (!state.isInitialized) return <Loader />;

  return (
    <JWTContext.Provider
      value={{
        ...state,
        login,
        logout,
        resetPassword,
        updateProfile
      }}
    >
      {children}
    </JWTContext.Provider>
  );
};

export default JWTContext;
